import script from "./TabMostrarListas.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabMostrarListas.vue?vue&type=script&setup=true&lang=ts"

import "./TabMostrarListas.vue?vue&type=style&index=0&id=39de7f91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39de7f91"]])

export default __exports__